var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSepa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_1981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0351562 12.68H7.44653V13.7689H6.13133L9.02705 18L11.9229 13.7689H10.6077V12.68H18.0191V0H0.0351562V12.68ZM9.02705 16.1342L8.12947 14.8226H8.50026V10.5726H9.55399V14.8226H9.92477L9.02705 16.1342ZM10.6077 11.6263V9.51883H7.44653V11.6263H1.08888V6.35765H16.9654V11.6263H10.6077ZM1.08888 5.30379V3.16118H16.9654V5.30379H1.08888ZM16.9654 1.05373V2.10745H1.08888V1.05373H16.9654Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14258 10.5723H6.39278V7.41113H2.14258V10.5723ZM3.1963 8.46486H5.33891V9.51859H3.1963V8.46486Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44629 7.41113H15.9114V8.46486H7.44629V7.41113Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6611 9.51855H15.9113V10.5723H11.6611V9.51855Z",
    fill: "#3F3F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_1981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepa);
export default __webpack_public_path__ + "static/media/sepa.26c795d1622e876e6eef2896e46355c3.svg";
export { ForwardRef as ReactComponent };